import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Box, Divider, Tooltip, Typography } from "@mui/material";
import { LayersOutlined } from "@mui/icons-material";

import HoverablePaper from "components/Shared/HoverablePaper";
import TableFilter from "components/Shared/AppTable/TableFilter";
import HighlightedText from "components/Shared/HighlightedText";
import EmptyResult from "components/Shared/Lottie/EmptyResult";

const FilterableList = ({ title = "", list = [] }) => {
  const [searchParams] = useSearchParams();

  const keyword = searchParams.get("search") || "";

  const sortedList = list
    ?.sort((a, b) => (a.name > b.name ? 1 : -1))
    ?.filter((item) =>
      item?.name?.toLowerCase().includes(keyword?.toLowerCase())
    );

  const filteredList = !!keyword?.length
    ? sortedList?.filter((item) =>
        item?.name?.toLowerCase().includes(keyword?.toLowerCase())
      )
    : sortedList;

  return (
    <>
      <TableFilter debounceDelay={0}>
        <div className="ml-2 font-medium">{title}</div>
      </TableFilter>

      {!!filteredList?.length ? (
        filteredList?.map((list, index) => (
          <React.Fragment key={`${list.name}-${index}`}>
            <Link
              to={`detail/${list?.name}?type=${list.name}`}
              style={{ color: "inherit" }}
            >
              <HoverablePaper>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  paddingX={3}
                  paddingY={2}
                >
                  <Typography>
                    <HighlightedText text={list.name} highlight={keyword} />
                  </Typography>

                  <Box display="flex" alignItems="center" gap={4}>
                    {!!list?.allowGrouping && (
                      <div className="rounded bg-green-50 px-2 py-1 text-sm text-green-500">
                        Group-able
                      </div>
                    )}

                    <Tooltip title="Max nested level" placement="left" arrow>
                      <Box display="flex" alignItems="center" gap={1}>
                        <LayersOutlined />

                        <Typography>{list.maxLevel}</Typography>
                      </Box>
                    </Tooltip>
                  </Box>
                </Box>
              </HoverablePaper>
            </Link>

            {index !== filteredList?.length - 1 && (
              <Box paddingX={3}>
                <Divider />
              </Box>
            )}
          </React.Fragment>
        ))
      ) : (
        <EmptyResult />
      )}
    </>
  );
};

export default FilterableList;
